const CampaignFolderIcon = ({ className }: { className?: string }) => (
  <svg
    width="37"
    height="31"
    viewBox="0 0 37 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <g clipPath="url(#campaign-folder-clip)">
      <path
        d="M18.0746 3.89349L13.9293 0.362185C13.6564 0.129783 13.3103 0 12.9553 0H1.14708C0.5134 0 0 0.528186 0 1.18012V29.8199C0 30.4718 0.5134 31 1.14708 31H35.8529C36.4866 31 37 30.4718 37 29.8199V5.43579C37 4.78386 36.4866 4.25567 35.8529 4.25567H19.0515C18.6966 4.25567 18.3504 4.12891 18.0775 3.89349H18.0746Z"
        fill="#B78F13"
      />
      <path
        d="M2.86039 5.5867H34.7733C34.9846 5.5867 35.1576 5.76477 35.1576 5.98209V26.4546C35.1576 26.6719 34.9846 26.85 34.7733 26.85H2.86039C2.64916 26.85 2.47607 26.6719 2.47607 26.4546V5.98209C2.47607 5.76477 2.64916 5.5867 2.86039 5.5867Z"
        fill="white"
      />
      <path
        d="M35.8353 7.07468H24.0271C23.6721 7.07468 23.326 7.20144 23.0531 7.43686L18.9049 10.9712C18.632 11.2036 18.2858 11.3334 17.9309 11.3334H1.12948C0.560339 11.3334 0.0909451 11.7589 0 12.3173V29.8229C0 30.4748 0.5134 31.003 1.14708 31.003H35.8529C36.4221 31.003 36.8915 30.5775 36.9824 30.0191V8.2548C36.9824 7.60286 36.469 7.07468 35.8353 7.07468Z"
        fill="#E8B000"
      />
    </g>
    <defs>
      <clipPath id="campaign-folder-clip">
        <rect width="37" height="31" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CampaignFolderIcon;
